"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEAM_STATE = exports.PLAYER_STATE = void 0;
exports.canBeSelectedByUser = canBeSelectedByUser;
exports.canJoinTeamWithState = canJoinTeamWithState;
exports.canPlayLeague = canPlayLeague;
exports.canTeamPlayLeague = canTeamPlayLeague;
exports.getPlayableStates = getPlayableStates;
exports.isActive = isActive;
exports.isBlocked = isBlocked;
exports.isDead = isDead;
exports.isInactive = isInactive;
exports.isPlayable = isPlayable;
exports.isRetirement = isRetirement;
exports.isTeamActive = isTeamActive;
exports.isTeamBlocked = isTeamBlocked;
exports.isTeamEmpty = isTeamEmpty;
exports.isTeamLessMin = isTeamLessMin;
exports.shouldBeRemovedFromTeam = shouldBeRemovedFromTeam;
const stadium_1 = require("./stadium");
var TEAM_STATE;
(function (TEAM_STATE) {
    TEAM_STATE[TEAM_STATE["ACTIVE"] = 0] = "ACTIVE";
    TEAM_STATE[TEAM_STATE["EMPTY"] = 1] = "EMPTY";
    TEAM_STATE[TEAM_STATE["BLOCKED"] = 2] = "BLOCKED";
})(TEAM_STATE || (exports.TEAM_STATE = TEAM_STATE = {}));
var PLAYER_STATE;
(function (PLAYER_STATE) {
    PLAYER_STATE[PLAYER_STATE["ACTIVE"] = 0] = "ACTIVE";
    PLAYER_STATE[PLAYER_STATE["RETIREMENT"] = 1] = "RETIREMENT";
    PLAYER_STATE[PLAYER_STATE["DEAD"] = 2] = "DEAD";
    PLAYER_STATE[PLAYER_STATE["INACTIVE"] = 3] = "INACTIVE";
    PLAYER_STATE[PLAYER_STATE["BLOCKED"] = 4] = "BLOCKED";
})(PLAYER_STATE || (exports.PLAYER_STATE = PLAYER_STATE = {}));
// WARNING, check the state, no the player
function isActive(state) {
    return state === PLAYER_STATE.ACTIVE;
}
function isInactive(state) {
    return state === PLAYER_STATE.INACTIVE;
}
function isBlocked(state) {
    return state === PLAYER_STATE.BLOCKED;
}
function isDead(state) {
    return state === PLAYER_STATE.DEAD;
}
function isRetirement(state) {
    return state === PLAYER_STATE.RETIREMENT;
}
function canJoinTeamWithState(state) {
    return state === PLAYER_STATE.ACTIVE;
}
function canBeSelectedByUser(state) {
    return state === PLAYER_STATE.ACTIVE || state === PLAYER_STATE.INACTIVE;
}
function canTeamPlayLeague(state) {
    return state === TEAM_STATE.ACTIVE;
}
function isTeamEmpty(state) {
    return state === TEAM_STATE.EMPTY;
}
function isTeamLessMin(team) {
    return team.players && team.players.length < stadium_1.MIN_SCRIMMAGE;
}
function isTeamBlocked(state) {
    return state === TEAM_STATE.BLOCKED;
}
function isTeamActive(state) {
    return state === TEAM_STATE.ACTIVE;
}
function canPlayLeague(team) {
    if (isTeamEmpty(team.state) ||
        isTeamBlocked(team.state) ||
        isTeamLessMin(team)) {
        return false;
    }
    // if (team.id === "c28c487a-5b6c-45a2-be33-9b3460b957b6") {
    //   return false;
    // }
    return true;
}
function getPlayableStates() {
    return [PLAYER_STATE.ACTIVE, PLAYER_STATE.INACTIVE];
}
function isPlayable(state) {
    return getPlayableStates().indexOf(state) !== -1;
}
function shouldBeRemovedFromTeam(state) {
    return state === PLAYER_STATE.BLOCKED || state === PLAYER_STATE.DEAD;
}
